import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import * as React from 'react';
/**
 * Deezer icon.
 */
const Deezer = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 176 115"
    {...props}
    className={cn('w-full', props.className)}
  >
    <path fill="#29AB70" d="M175.312.71h-37.905v22.003h37.905V.71z" />
    <path fill="url(#a)" d="M175.312 31.352h-37.905v22.003h37.905V31.352z" />
    <path fill="url(#b)" d="M175.312 61.98h-37.905v22.002h37.905V61.98z" />
    <path fill="url(#c)" d="M37.905 92.623H0v22.002h37.905V92.623z" />
    <path fill="url(#d)" d="M83.702 92.623H45.797v22.002h37.905V92.623z" />
    <path fill="url(#e)" d="M129.515 92.623H91.61v22.002h37.905V92.623z" />
    <path fill="url(#f)" d="M175.312 92.623h-37.905v22.002h37.905V92.623z" />
    <path fill="url(#g)" d="M129.515 61.98H91.61v22.002h37.905V61.98z" />
    <path fill="url(#h)" d="M83.702 61.98H45.797v22.002h37.905V61.98z" />
    <path fill="url(#i)" d="M83.702 31.352H45.797v22.003h37.905V31.352z" />
    <defs>
      <linearGradient
        id="a"
        x1={158.825}
        x2={153.945}
        y1={56.24}
        y2={28.443}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C8C9D" />
        <stop offset={0.04} stopColor="#298E9A" />
        <stop offset={0.39} stopColor="#129C83" />
        <stop offset={0.72} stopColor="#05A475" />
        <stop offset={1} stopColor="#00A770" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={136.842}
        x2={175.791}
        y1={82.874}
        y2={62.92}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2839BA" />
        <stop offset={1} stopColor="#148CB3" />
      </linearGradient>
      <linearGradient
        id="c"
        x2={37.905}
        y1={103.616}
        y2={103.616}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F6A500" />
        <stop offset={1} stopColor="#F29100" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={45.797}
        x2={83.702}
        y1={103.616}
        y2={103.616}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F29100" />
        <stop offset={1} stopColor="#D12F5F" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={91.61}
        x2={129.515}
        y1={103.616}
        y2={103.616}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B4197C" />
        <stop offset={1} stopColor="#472EAD" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={137.407}
        x2={175.312}
        y1={103.616}
        y2={103.616}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2839BA" />
        <stop offset={1} stopColor="#3072B7" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={90.114}
        x2={130.961}
        y1={78.926}
        y2={66.919}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B4197C" />
        <stop offset={1} stopColor="#373AAC" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={44.469}
        x2={84.995}
        y1={65.639}
        y2={80.462}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCB00" />
        <stop offset={1} stopColor="#D12F5F" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={49.003}
        x2={80.342}
        y1={27.89}
        y2={56.968}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFCF00" />
        <stop offset={1} stopColor="#ED743B" />
      </linearGradient>
    </defs>
  </svg>
);

export default Deezer;
